// Exportar componentes principales
export { default as ThoughtRenderer } from './ThoughtRenderer';
export { ThoughtItem } from './ThoughtItem';
export { default as DefaultToolResult } from './toolResults/DefaultToolResult';
export { default as ListDocumentsResult } from './toolResults/ListDocumentsResult';
export { default as GetDocumentContentResult } from './toolResults/GetDocumentContentResult';
export { default as WordGetDocumentTextResult } from './toolResults/WordGetDocumentTextResult';
export { default as DocumentEditResult } from './toolResults/DocumentEditResult';
export { default as WebSearchResult } from './toolResults/WebSearchResult';
export { default as FindTextResult } from './toolResults/FindTextResult';

// Exportar funciones de registro
export { registerComponent, getComponent } from './registry';

// Exportar tipos
export type {
  Thought,
  ThoughtType,
  BaseThought,
  ToolResultThought,
  AgentUpdateThought,
  ToolCallThought,
  ToolResultProps,
  AgentUpdateProps,
  ToolCallProps
} from './types';

// Registrar componentes por defecto
import { registerComponent } from './registry';
import ListDocumentsResult from './toolResults/ListDocumentsResult';
import GetDocumentContentResult from './toolResults/GetDocumentContentResult';
import DefaultToolResult from './toolResults/DefaultToolResult';
import WordGetDocumentTextResult from './toolResults/WordGetDocumentTextResult';
import DocumentEditResult from './toolResults/DocumentEditResult';
import WebSearchResult from './toolResults/WebSearchResult';
import FindTextResult from './toolResults/FindTextResult';

// Registrar toolResults
// Nota: Los nombres se normalizan automáticamente (case-insensitive, guiones normalizados)
registerComponent('tool_result', 'list_documents', ListDocumentsResult);
registerComponent('tool_result', 'websearch', WebSearchResult);
registerComponent('tool_result', 'web_search', WebSearchResult);
registerComponent('tool_result', 'get_document_content', GetDocumentContentResult);
// Registrar variaciones comunes del nombre (ya normalizadas)
registerComponent('tool_result', 'getdocumentcontent', GetDocumentContentResult);
registerComponent('tool_result', 'get-document-content', GetDocumentContentResult);
registerComponent('tool_result', 'GetDocumentContent', GetDocumentContentResult);
registerComponent('tool_result', 'wordgetdocumenttext', WordGetDocumentTextResult);
// Registrar tools de edición de documentos
registerComponent('tool_result', 'word_create_edit_plan_tool', DocumentEditResult);
registerComponent('tool_result', 'word_mark_as_finished_tool', DocumentEditResult);
registerComponent('tool_result', 'find_text', FindTextResult);
registerComponent('tool_result', 'find-text', FindTextResult);
registerComponent('tool_result', 'FindText', FindTextResult);
registerComponent('tool_result', 'wordfindtextindocument', FindTextResult);
registerComponent('tool_result', '*', DefaultToolResult); // Fallback por defecto






